import { render, staticRenderFns } from "./lazy-img.vue?vue&type=template&id=95e4234a"
import script from "./lazy-img.vue?vue&type=script&lang=js"
export * from "./lazy-img.vue?vue&type=script&lang=js"
import style0 from "./lazy-img.vue?vue&type=style&index=0&id=95e4234a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports